/**
 * Encode/decode single URL path segments whose values must round-trip exactly
 * (e.g. Algolia/Dynamo company IDs, opaque facet keys).
 *
 * Built on {@link encodeURIComponent} / {@link decodeURIComponent}, with one twist: literal
 * spaces are swapped for literal hyphens (readable "Acme-Oy" instead of "Acme%20Oy") and any
 * *real* hyphen in the source is percent-encoded first (`-` -> `%2D`) so the swap stays
 * unambiguous and fully reversible — decode always recovers the exact original string.
 *
 * SEO slug segments (title/location/remoteness joined with hyphens) stay on
 * {@link sanitizeForUrl} — they are not opaque storage keys.
 */

export function encodeOpaqueUrlPathSegment(raw: unknown): string {
  if (raw == null || typeof raw !== 'string') return '';
  const t = raw.trim();
  if (!t) return '';
  return encodeURIComponent(t).replace(/-/g, '%2D').replace(/%20/g, '-');
}

export function decodeOpaqueUrlPathSegment(segment: string): string {
  const s = String(segment ?? '');
  if (!s) return '';
  try {
    return decodeURIComponent(s.replace(/-/g, '%20'));
  } catch {
    return s;
  }
}
